import MUIAssetTypesDropdown from "./MUIAssetTypesDropdown";
import PrimeReactAssetTypesDropdown from "./PrimeReactAssetTypesDropdown";

export interface AssetTypesDropdownProps {
  selectedAssetType?: string;
  minWidth?: string;
  onAssetTypeChange: (assetType: string) => void;
  error?: string;
}

export interface Option {
  value: string;
  label: string;
}

export default function AssetTypesDropdown({
  isPrimeReact,
  ...props
}: AssetTypesDropdownProps & { isPrimeReact?: boolean }) {
  return isPrimeReact ? <PrimeReactAssetTypesDropdown {...props} /> : <MUIAssetTypesDropdown {...props} />;
}
